import App from "./App";
import { createRoot } from "react-dom/client";
import WebFont from "webfontloader";
import { GetlifeProvider } from "./context/GetLifeContext.context";
import { WithI18n } from "./context/i18n.context";
import { BrowserRouter as Router } from "react-router-dom";
import { GetLifeTrackerProvider } from "./context/GetLifeTracker.context";
import { StatusProvider } from "./context/StatusContext";
import { TrackingProvider } from "./context/Tracking.context";
import ClickIdUrlKeeper from "./components/ClickIdUrlKeeper";

WebFont.load({
  google: {
    families: ["Montserrat:500,600,700", "sans-serif"],
  },
});

const root = createRoot(document.querySelector("#root"));

root.render(
  <WithI18n>
    <GetlifeProvider>
      <Router>
        <ClickIdUrlKeeper />
        <TrackingProvider>
          <GetLifeTrackerProvider>
            <StatusProvider>
              <App />
            </StatusProvider>
          </GetLifeTrackerProvider>
        </TrackingProvider>
      </Router>
    </GetlifeProvider>
  </WithI18n>
);
